import React from 'react';
import cl from './HowItWorks.module.css';
import useReveal from '../../hooks/useReveal';

// 4 простых шага — от регистрации до первой группы.
const steps = [
    {
        title: 'Зарегистрируйтесь',
        text: 'За 2 минуты создайте аккаунт центра. Получите доступ к демо — 50 учеников с 5 курсами в подарок.',
    },
    {
        title: 'Изучите платформы',
        text: 'Посмотрите все курсы, прокликайте уроки и задачи, оцените, как это будут видеть ваши дети.',
    },
    {
        title: 'Оплатите тариф',
        text: 'Один платёж — 150 000 ₽ в год или 25 000 ₽ в месяц. Тут же открываются 200 учеников и 5 преподавателей.',
    },
    {
        title: 'Запускайте группы',
        text: 'Создавайте учеников в своём кабинете, давайте им доступ и набирайте группы. Поддержка — на связи.',
    },
];

export default function HowItWorks() {
    const revealRef = useReveal();
    return (
        <section className={cl.how} id="how-it-works" ref={revealRef}>
            <div className={cl.inner}>
                <div className={cl.head}>
                    <span className={cl.eyebrow} data-reveal="down">Как это работает</span>
                    <h2 className={cl.title} data-reveal="up" style={{ '--reveal-delay': '100ms' }}>
                        От регистрации до первой группы — за неделю
                    </h2>
                    <p className={cl.subtitle} data-reveal="up" style={{ '--reveal-delay': '180ms' }}>
                        Не нужно ничего настраивать, нанимать преподавателей
                        и закупать оборудование. Всё работает «из коробки».
                    </p>
                </div>

                <div className={cl.steps} data-reveal-stagger>
                    {steps.map((s, i) => (
                        <div key={s.title} className={cl.step}
                            data-reveal={i % 2 === 0 ? 'left' : 'right'}>
                            <div className={cl.num}>{i + 1}</div>
                            <div className={cl.body}>
                                <h3 className={cl.stepTitle}>{s.title}</h3>
                                <p className={cl.stepText}>{s.text}</p>
                            </div>
                        </div>
                    ))}
                </div>

                <div className={cl.timing} data-reveal="pop" style={{ '--reveal-delay': '300ms' }}>
                    <span>
                        Среднее время до первого ученика — <b>3–5 дней</b>.
                        Регистрация и демо — <b>бесплатно</b>.
                    </span>
                </div>
            </div>
        </section>
    );
}
